import { Button, Table } from "react-bootstrap";
import { createStructuredSelector } from "reselect";
import {
    getPartnerAddPostbackErrorSelector,
    getPartnerIsAddPostbackLoadingSelector,
    getPartnerIsUpdatePostbackLoadingSelector,
    getPartnerUpdatePostbackErrorSelector
} from "../partnerSelectors";
import { connect } from "react-redux";
import { Fragment, useCallback } from "react";
import {
    addPartnerPostbackAction,
    deletePartnerPostbackAction,
    resetAddPartnerPostbackErrorAction,
    resetUpdatePartnerPostbackErrorAction,
    updatePartnerPostbackAction
} from "../partnerActions";
import { BinIcon } from "../../../components/icon/Icon";
import { Tooltip } from "../../../components/Tooltip/Tooltip";
import { openModalAction } from "../../../app/appActions";
import { MODALS_NAME } from "../../Modals/modalsConstants";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

function PartnerPostbacksActionButton(props) {
    const {active, iconName, item, onClick, tooltip} = props;

    const handleClick = useCallback(() => {
        onClick(item);
    }, [item, onClick]);

    return <Tooltip text={tooltip}>
        <Button
                active={active}
                variant="info"
                size="sm"
                onClick={handleClick}
        >
            <BinIcon name={iconName} style={{fill: 'var(--icon-primary-color)'}}/>
        </Button>
    </Tooltip>
}

function PartnerPostbacks(props) {
    const {
        campaignId,
        className,
        deletePartnerPostbackAction,
        openModalAction,
        postbacksList,
    } = props;
    const {getLangPath} = useLangContext();

    const handleAddPostbackButtonClick = useCallback(() => {
        openModalAction({
            name: MODALS_NAME.PARTNER_ADD_POSTBACK,
            params: {campaignId},
        })
    }, [campaignId, openModalAction]);

    const handleUpdateActionClick = useCallback((item) => {
        openModalAction({
            name: MODALS_NAME.PARTNER_UPDATE_POSTBACK,
            params: {campaignId, item}
        })
    }, [campaignId, openModalAction]);

    const handleDeleteActionClick = useCallback((item) => {
        const isConfirmed = window.confirm(getLangPath('partner.postbacks.confirm'));
        if (isConfirmed) {
            deletePartnerPostbackAction({id: item.id});
        }
    }, [deletePartnerPostbackAction, getLangPath]);

    return <>
        <Table striped bordered hover variant="dark" className={className}>
            <thead>
            <tr>
                <th>{getLangPath('partner.postbacks.type')}</th>
                <th>{getLangPath('partner.postbacks.url')}</th>
                <th style={{width: '100px'}}>{getLangPath('partner.postbacks.actions')}</th>
            </tr>
            </thead>
            <tbody>
            {
                postbacksList.map((item) => (
                        <Fragment key={item.id}>
                            <tr>
                                <td>{item.type}</td>
                                <td>{item.url}</td>
                                <td className="d-flex gap-2 justify-content-center">
                                    <PartnerPostbacksActionButton
                                            item={item}
                                            iconName="IcPencil"
                                            onClick={handleUpdateActionClick}
                                            tooltip={getLangPath('partner.postbacks.edit')}
                                    />
                                    <PartnerPostbacksActionButton
                                            item={item}
                                            iconName="IcXMark"
                                            onClick={handleDeleteActionClick}
                                            tooltip={getLangPath('partner.postbacks.delete')}
                                    />
                                </td>
                            </tr>
                        </Fragment>
                ))
            }
            </tbody>
        </Table>
        <div>
            <Button variant="primary" size='md' onClick={handleAddPostbackButtonClick}>
                {getLangPath('partner.postbacks.add_postback_url_button')}
            </Button>
        </div>
    </>
}

const mapStateToProps = createStructuredSelector({
    addPostbackError: getPartnerAddPostbackErrorSelector,
    isAddPostbackLoading: getPartnerIsAddPostbackLoadingSelector,
    isUpdatePostbackLoading: getPartnerIsUpdatePostbackLoadingSelector,
    updatePostbackError: getPartnerUpdatePostbackErrorSelector,
});

const mapDispatchToProps = {
    addPartnerPostbackAction,
    deletePartnerPostbackAction,
    openModalAction,
    resetAddPartnerPostbackErrorAction,
    resetUpdatePartnerPostbackErrorAction,
    updatePartnerPostbackAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerPostbacks);
